import React from 'react';

const HotelDetails = () => {
  return (
    <div id="App"></div>
  );
};

export default HotelDetails; 